import Button from "atoms/buttons/button";
import Icon from "atoms/icons/icon";
import { Icons } from "atoms/constants/icons";
import React, { forwardRef } from "react";
import { t } from "utilities/localization-utils";
import NotebookRecord from "models/view-models/notebook-record";

export interface ShareNotebookMenuItemProps {
    notebook: NotebookRecord;
    onClick: () => void;
    canShare: boolean;
}

const ShareNotebookMenuItem = forwardRef<
    HTMLButtonElement,
    ShareNotebookMenuItemProps
>((props, ref) => {
    const { onClick, canShare } = props;

    return (
        canShare && (
            <>
                <Button
                    dataTestId="share-notebook-menu-item--button"
                    accessibleText={t("shareItem", {
                        item: t("notebook"),
                    })}
                    cssClassName={"-icon-left"}
                    onClick={onClick}>
                    <Icon type={Icons.Share} />
                    {t("shareNotebook")}
                </Button>
            </>
        )
    );
});

export default ShareNotebookMenuItem;
